import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../src/assets/sty/_themes.css'
import 'element-ui/lib/theme-chalk/index.css'

import axiosInstance from './axios-config';  // 导入axios配置

import store from './store'

Vue.use(BootstrapVue)
// Vue.use(IconsPlugin)


import i18n from './i18n';
import 'animate.css';

//引入VueRouter
import VueRouter from 'vue-router'
//引入路由器
import router from './router'
Vue.config.productionTip = false




const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
//解决报错。【https://blog.csdn.net/luer_LJS/article/details/108362563】


import {Input,Upload,Message,Cascader,Button,TabPane,Tabs,Tree,Loading} from 'element-ui';


Vue.component(Input.name, Input);
Vue.component(Upload.name, Upload);
Vue.component(Cascader.name, Cascader);
Vue.component(Button.name, Button);
Vue.component(TabPane.name, TabPane);
Vue.component(Tabs.name, Tabs);
Vue.component(Tree.name, Tree);

Vue.prototype.$message = Message;

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service


Vue.use(VueRouter)
Vue.prototype.$axios = axiosInstance;

new Vue({
  render: h => h(App),
  router,
  i18n,
  store,

}).$mount('#app')
